<template>
    <div>
      <iframe border="0" allow="display-capture" allowfullscreen="true" :src="src" width="100%" height="212px"></iframe>
      <div class="title">{{ title }}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: 'start', // start | end 
            title: '',
            src: ''
        };
    },
    mounted() {
        this.type = this.$route.query.type || ''
        if (this.type === 'start') {
            this.title = this.$t(`jetlympic.video.title_1`)
            this.src = 'https://live-wka0q1.vhall.com/v3/lives/embedclientvideo/watch/763869101?embed=video'
            document.title = '开幕式'
        } else if (this.type === 'end') {
            this.title = this.$t(`jetlympic.video.title_2`)
            this.src = 'https://live-wka0q1.vhall.com/v3/lives/embedclientvideo/watch/545285537?embed=video'
            document.title = '闭幕式'
        } else if (this.type === 'mini') { 
            this.title = this.$t(`jetlympic.video.title_3`)
            this.src = 'https://live-wka0q1.vhall.com/v3/lives/embedclientvideo/watch/607971524?embed=video'
            document.title = 'MINI马拉松'
        }
    },
    methods: {

    },
};
</script>

<style scoped lang="scss">
.title{
    padding: 0 16px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-top: 16px;
}
</style>
